import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { GhostButton } from './shortcuts';

export const GhostLinkButton = styled(GhostButton)`
  &&& {
    && {
      color: ${colors.link};
      padding: 0 ${spacing.quarter};
      margin: 0 ${spacing.quarter};

      &:focus {
        color: ${colors.linkFocus};
        :before {
          border-color: ${colors.linkFocusOutline};
        }
      }
      &:active {
        color: ${colors.linkActive};
      }
      &:hover {
        color: ${colors.linkHover};
      }
    }
  }
`;
